import {_t} from "./translations";
import {IStandingRow} from "../api/match-center";

interface IPromotionCode {
  code: string;
  name: string;
}

const promotionCodes: IPromotionCode[] = [
  {
    code: 'promotion',
    name: 'Promotion',
  },
  {
    code: 'championsleague',
    name: 'Champions League',
  },
  {
    code: 'playoff',
    name: 'Playoff',
  },
  {
    code: 'qualification_to_next_stage',
    name: 'Qualification to next stage',
  },
  {
    code: 'promotionplayoff',
    name: 'Promotion Playoff',
  },
  {
    code: 'championsleaguequal',
    name: 'Champions League qualification',
  },
  {
    code: 'possible_qualification_to_next_stage',
    name: 'Possible qualification to next stage',
  },
  {
    code: 'uefacup',
    name: 'Uefa Cup',
  },
  {
    code: 'uefaqual',
    name: 'Uefa Qualification',
  },
  {
    code: 'relegationplayoff',
    name: 'Relegation Playoff',
  },
  {
    code: 'relegation',
    name: 'Relegation',
  },
];

export const getPromotionName = (promotionCode: string): string|null => {
  const PromotionName = promotionCodes.find((promotion) => promotionCode === promotion.code)?.name;
  return PromotionName ? _t(PromotionName) : null;
}

export const isGoalsDataAvailable = (rows: IStandingRow[]) => {
  let result = rows.filter((item) => {
    return item.goalsfor !== null && item.goalsagainst !== null && item.goalsdiff !== null;
  });

  return result.length > 0;
}
